import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'Orderplanning',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '82c898ca-bc2d-4ce1-9ce0-c635fd17cbf0',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2cdev.b2clogin.com/tfp/agrifirmb2cdev.onmicrosoft.com/',
  APPLICATION_KEY: 'Orderplanning',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [IETFLocales.nl, IETFLocales.en],
  PRODUCTION: false,
  FIELD_ADVICE_URL: '',
  FIELD_PLAN_URL: '',
  ENABLE_SEND_ORDER: true,
  CART_ENABLED: true,
  USE_PRODUCT_V2_ID: true,
  RELATIONSHIPS_ELASTIC_SEARCH: true,
  SHOW_CART_ICON: true,
  SHOP_URL: 'https://webshop.c4htest.mcps.agrifirm.com',
  APIM_BASE_URL: 'https://gateway.api.testing.agrifirm.com/external',
  SUBSCRIBE_TO_CART_EVENTS: true,
  AZURE_MAPS_SUBSCRIPTION_KEY: '',
  AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: '',
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  DELIVERY_TIME_WINDOW_DISABLED: false,
  SHOW_DISABLED_LOCATION_BADGE: false,
  IS_MY_PROSPECTS_HIDDEN: false,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
  PRE_SALES_REBUILD_DONE: true,
  FIELD_ADVICE_REBUILD_DONE: false,
};
